import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Search } from "lucide-react";
import HealthServiceCard from "../../../components/health/health-service-card";
const FindHealthService = () => {
   
    return (
        <>
            <div className="p-2">
                <div className="text-2xl md:text-3xl text-gray-900 font-semibold mb-6 md:mb-8">
                    Find Health Service
                </div>
                <div className="flex w-full gap-4 mb-4">
                    <div className="flex-1">
                        <div className="relative w-full">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4"/>
                            <Input
                                type="search"
                                placeholder="Enter Pincode (e.g.-842001) and Name"
                                className="pl-9"
                            />
                        </div>
                    </div>
                    <div >
                        <Button
                            variant="patient.tracery"
                            size="lg">
                            Search
                        </Button>
                    </div>
                </div>
                <HealthServiceCard/>
            </div>
        </>
    );
};

export default FindHealthService;
